"use client";
import { Box, Button, Menu, MenuItem, Stack, Typography } from "@mui/material";
import Image from "next/image";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { useState } from "react";
import { useRouter, usePathname } from "next/navigation";

export function NavBar() {
  const router = useRouter();
  const pathname = usePathname();

  const menuList = [
    { title: "เกี่ยวกับเรา", route: "/about-us" },
    { title: "คุณภาพของแบรนด์", route: "/brand-quality" },
    { title: "ผลิตภัณฑ์", route: "/products" },
    { title: "เมนูแนะนำ", route: "/recommended-menus" },
    { title: "รีวิว", route: "/reviews" },
    { title: "โปรโมชั่น", route: "/promotions" },
    { title: "ข่าวสาร&กิจกรรม", route: "/news-events" },
  ];

  const [isOpenMenu, setIsOpenMenu] = useState(false);

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
    setIsOpenMenu(true);
  };
  const handleClose = () => {
    setAnchorEl(null);
    setIsOpenMenu(false);
  };

  const handleNavigate = (route: string) => {
    router.push(route);
    handleClose(); // Close mobile menu if open
  };

  const isActiveRoute = (route: string) => {
    return pathname === route;
  };

  return (
    <>
      <Stack
        px={20}
        py={2}
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        display={{
          xs: "none",
          md: "flex",
        }}
        position="absolute"
        top={0}
        left={0}
        zIndex={10}
        width="100%"
      >
        <Image
          onClick={() => handleNavigate("/")}
          style={{
            cursor: "pointer",
          }}
          src="/images/logo.png"
          width={77}
          height={48}
          alt="Picture of the Logo"
        />
        <Stack direction="row">
          {menuList.map((menu, index) => {
            const isActive = isActiveRoute(menu.route);
            return (
              <Box
                key={`${menu}-${index}`}
                px={4}
                py={2}
                onClick={() => handleNavigate(menu.route)}
                sx={{
                  cursor: "pointer",
                  "&:hover": {
                    opacity: 0.8,
                  },
                }}
              >
                <Typography
                  fontSize={14}
                  fontWeight={400}
                  color={isActive ? "#E12B2A" : "textPrimary"}
                >
                  {menu.title}
                </Typography>
              </Box>
            );
          })}
        </Stack>
        <Button
          color="secondary"
          variant="contained"
          onClick={() => handleNavigate("/contact-us")}
        >
          <Typography fontSize={13} fontWeight={400} color="textPrimary">
            ติดต่อเรา
          </Typography>
        </Button>
      </Stack>
      <Stack
        px={4}
        py={2}
        direction="row"
        display={{
          xs: "flex",
          md: "none",
        }}
        justifyContent="space-between"
        alignItems="center"
        position="absolute"
        top={0}
        left={0}
        zIndex={10}
        width="100%"
      >
        <Image
          onClick={() => handleNavigate("/")}
          src="/images/logo.png"
          width={57}
          height={36}
          alt="Picture of the Logo"
        />
        <MenuRoundedIcon
          onClick={handleClick}
          style={{
            color: "#fff",
          }}
        />
        {isOpenMenu && (
          <Menu
            component={Stack}
            anchorEl={anchorEl}
            open={isOpenMenu}
            onClose={handleClose}
            sx={{
              padding: "8px 12px",
              justifyContent: "center",
            }}
            anchorOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
          >
            <MenuItem
              sx={{
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <CloseRoundedIcon
                onClick={() => setIsOpenMenu(false)}
                style={{
                  color: "#fff",
                }}
              />
            </MenuItem>
            {menuList.map((menu, index) => {
              const isActive = isActiveRoute(menu.route);
              return (
                <MenuItem
                  key={`${menu}-${index}`}
                  onClick={() => handleNavigate(menu.route)}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <Typography
                    fontSize={14}
                    fontWeight={400}
                    color={isActive ? "#E12B2A" : "textPrimary"}
                    textAlign="center"
                  >
                    {menu.title}
                  </Typography>
                </MenuItem>
              );
            })}
            <MenuItem
              sx={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Stack mb={10} mt={6} justifyContent="center" alignItems="center">
                <Button
                  color="secondary"
                  variant="contained"
                  sx={{
                    width: "fit-content",
                    padding: "10px 24px",
                  }}
                  onClick={() => handleNavigate("/contact-us")}
                >
                  <Typography
                    fontSize={13}
                    fontWeight={400}
                    color="textPrimary"
                  >
                    ติดต่อเรา
                  </Typography>
                </Button>
              </Stack>
            </MenuItem>
          </Menu>
        )}
      </Stack>
    </>
  );
}
